import script from "./CaptchaLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptchaLogin.vue?vue&type=script&setup=true&lang=js"

import "./CaptchaLogin.vue?vue&type=style&index=0&id=4f80defc&scoped=true&lang=less"

import exportComponent from "E:\\code\\软著项目\\software\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f80defc"]])

export default __exports__